<template>
  <v-container fluid>
    <v-simple-table v-if="travelcost.record_guide.description">
      <thead class="font-weight-bold">
        <tr>
          <td width="300">
            Guide
          </td>
          <td>Cost</td>
          <td colspan="2">
            Duration
          </td>

          <td>Total</td>
          <td>Per Pax</td>
          <td>Status Payment</td>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>{{ travelcost.record_guide.description }}</td>
          <td>Rp. {{ Number(travelcost.record_guide.cost).toLocaleString() }}</td>
          <td>
            {{ travelcost.record_guide.duration }}
          </td>
          <td colspan="2">
            Rp. {{ Number(travelcost.record_guide.total).toLocaleString() }}
          </td>
          <td>Rp. {{ Number(travelcost.record_guide.per_pax).toLocaleString() }}</td>
          <td>
            <v-chip :color="getColor(travelcost.record_guide.status_payment)">
              {{ travelcost.record_guide.status_payment }}
            </v-chip>
            <v-btn
              v-if="$store.state.user.level_user === 'Accounting' || $store.state.user.level_user === 'Admin' "
              class=" ml-1"
              rounded
              small
              @click="ChangeStatusPayment(travelcost.record_guide ,'Guide')"
            >
              <v-icon>{{ icons.mdiPencil }}</v-icon> <br>
            </v-btn><br>
            <span v-if="travelcost.record_guide.status_payment == 'Paid'">

              Date Payment : {{ travelcost.record_guide.date_payment }} <br>
              Ket Payment    : {{ travelcost.record_guide.ket_payment }}
            </span>
          </td>
        </tr>
      </tbody>
    </v-simple-table>

    <v-simple-table class="mt-5">
      <thead class="font-weight-bold">
        <tr>
          <td width="300">
            Description
          </td>
          <td>Cost</td>
          <td width="90">
            Qty
          </td>
          <td width="90">
            Nt
          </td>
          <td>Total</td>
          <td>Per Pax</td>
        </tr>
      </thead>
      <tbody>
        <tr
          v-for="(tc,index) in travelcost.variablecost"
          :key="index"
        >
          <td>{{ tc.description }}</td>
          <td>Rp. {{ Number(tc.cost).toLocaleString() }}</td>
          <td>{{ tc.qty }}</td>
          <td>{{ tc.nt }}</td>
          <td>
            Rp. {{ Number(tc.total).toLocaleString() }}
          </td>
          <td>Rp. {{ Number(tc.per_pax).toLocaleString() }}</td>
        </tr>
      </tbody>
      <tfoot>
        <tr class="font-weight-bold">
          <td colspan="4">
            Total Per Pax
          </td>
          <td>
            Status Payment  :   <v-chip :color="getColor(travelcost.variablecost[0].status_payment)">
              {{ travelcost.variablecost[0].status_payment }}
            </v-chip>
            <v-btn
              v-if="$store.state.user.level_user === 'Accounting' || $store.state.user.level_user === 'Admin' "
              class=" ml-1"
              rounded
              small
              @click="ChangeStatusPayment(travelcost.variablecost ,'VariableCost')"
            >
              <v-icon>{{ icons.mdiPencil }}</v-icon>
            </v-btn><br>
            <span v-if="travelcost.variablecost[0].status_payment == 'Paid'">

Date Payment : {{ travelcost.variablecost[0].date_payment }} <br>
Ket Payment    : {{ travelcost.variablecost[0].ket_payment }}
</span>
          </td>
          <td colspan="2">
            Rp. {{ Number(travelcost.grandtotaltravelcostperpax).toLocaleString() }}
          </td>
        </tr>

        <tr class="font-weight-bold">
          <td colspan="4">
            Total Travel Cost
          </td>

          <td colspan="3">
            Rp. {{ Number(travelcost.grandtotaltravelcost).toLocaleString() }}
          </td>
        </tr>
      </tfoot>
    </v-simple-table>

    <v-dialog
      v-model="dialogPayment"
      scrollable
      max-width="500px"
    >
      <v-card>
        <v-card-title>Select Status Payment</v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <v-select
            v-model="payment.status_payment"
            dense
            outlined
            :items="['Waiting For Payment','Paid','Canceled']"
          />
          <v-menu
            v-if="payment.status_payment == 'Paid'"
            ref="menu"
            v-model="menu"
            :close-on-content-click="false"
            :return-value.sync="payment.date_payment"
            transition="scale-transition"
            offset-y
            min-width="auto"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                v-if="payment.status_payment == 'Paid'"
                v-model="payment.date_payment"
                label="Date Payment"
                readonly
                dense
                outlined
                v-bind="attrs"
                v-on="on"
              ></v-text-field>
            </template>
            <v-date-picker
              v-model="payment.date_payment"
              no-title
              scrollable
            >
              <v-spacer></v-spacer>
              <v-btn
                text
                color="primary"
                @click="menu = false"
              >
                Cancel
              </v-btn>
              <v-btn
                text
                color="primary"
                @click="$refs.menu.save(payment.date_payment)"
              >
                OK
              </v-btn>
            </v-date-picker>
          </v-menu>
          <v-textarea
            v-if="payment.status_payment == 'Paid'"
            v-model="payment.ket_payment"
            dense
            outlined
            label="Keterangan Payment"
          />
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-btn
            class="ml-auto"
            color="primary"
            @click="SaveStatusPayment()"
          >
            Save
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>

import axios from 'axios'
import {
  mdiPencil,
  mdiTrashCan,
  mdiPlus,
  mdiClose,
  mdiCalendar,
} from '@mdi/js'

export default {
  props: ['datacost'],
  data() {
    return {
      icons: {
        mdiPencil,
        mdiTrashCan,
        mdiPlus,
        mdiClose,
        mdiCalendar,
      },
      travelcost: {
        record_guide: {
          id_guide: '',
          description: '',
          cost: '',
          duration: 1,
          total: '',
          per_pax: '',
        },
        grandtotaltravelcost: 0,
        grandtotaltravelcostperpax: 0,
        variablecost: [{
          status_payment: '-',
        }],
      },
      menu: false,
      dialogPayment: false,
      payment: {
        jenis: '-',
        date_payment: '',
      },

    }
  },
  created() {
    this.initialize()
  },
  methods: {
    SaveStatusPayment() {
      this.$root.$emit('PesanLoading', 'Processing Data')
      axios.post('auth/SaveStatusPaymentTravelCost', this.payment).then(response => {
        this.$root.$emit('PesanResponse', response.data.message, 'primary')
        this.data = response.data.data
        this.initialize()
        this.dialogPayment = false
      }).catch(err => {
        this.errors = err.response.data.errors
        this.$root.$emit('PesanResponse', err.response.data.message, 'red')
      })
    },
    ChangeStatusPayment(item, jenis) {
      if (jenis === 'Guide') {
        this.payment = item
        this.payment.jenis = jenis
      } else {
        this.payment.variablecost = item
        this.payment.jenis = jenis
      }
      this.dialogPayment = true
    },
    getColor(status) {
      if (status === 'Waiting For Payment') {
        return 'success'
      }
      if (status === 'Canceled') {
        return 'error'
      }

      return 'primary'
    },
    CountCostTravel() {
      this.travelcost.grandtotaltravelcost = 0
      this.travelcost.grandtotaltravelcostperpax = 0
      let guidetotal = 0
      let guideperpax = 0
      let grandtotal = 0
      let grandtotalperpax = 0
      this.travelcost.variablecost.forEach(number => {
        // eslint-disable-next-line no-const-assign, radix
        grandtotal += parseInt(number.total)
        // eslint-disable-next-line no-const-assign, radix
        grandtotalperpax += parseInt(number.per_pax)
      })
      if (this.travelcost.record_guide.total) {
      // eslint-disable-next-line radix
        guidetotal += parseInt(this.travelcost.record_guide.total)
        // eslint-disable-next-line radix
        guideperpax += parseInt(this.travelcost.record_guide.per_pax)
      }

      // eslint-disable-next-line radix
      this.travelcost.grandtotaltravelcostperpax = (parseInt(grandtotalperpax) + parseInt(guideperpax))

      // eslint-disable-next-line radix
      this.travelcost.grandtotaltravelcost = (parseInt(grandtotal) + parseInt(guidetotal))
      this.$root.$emit('MakeInvoice', this.travelcost, 'travelcost')
    },
    initialize() {
      this.$root.$emit('PesanLoading', 'Processing Data')
      axios.post('auth/VariableCost', this.datacost).then(response => {
        if (response.data.data.record_guide !== null) {
          this.travelcost.record_guide = response.data.data.record_guide
        }

        if (response.data.data.variablecost.length > 0) {
          this.travelcost.variablecost = response.data.data.variablecost
        }

        this.$root.$emit('PesanResponse', response.data.message, 'primary')
        this.CountCostTravel()
      }).catch(err => {
        this.errors = err.response.data.errors
        this.$root.$emit('PesanResponse', err.response.data.message, 'red')
      })
    },
  },
}
</script>
